import ApplianceRender from "../ApplianceRender";
const AnimeshHarshit = () => {
    return (
        <ApplianceRender roomName={"AnimeshHarshit"}/>
    )
}

export default AnimeshHarshit